import fetchBookings from './fetchBookings';
import filterBookings from './filterBookings';

export default {
    fetchBookings,
    filterBookings,
};
